/**
 * DevExtreme (esm/renovation/ui/scheduler/workspaces/timeline/header_panel/layout.j.js)
 * Version: 23.1.5
 * Build date: Wed Aug 30 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import registerComponent from "../../../../../../core/component_registrator";
import {
    HeaderPanel
} from "../../../../../component_wrapper/scheduler/header_panel";
import {
    TimelineHeaderPanelLayout as TimelineHeaderPanelLayoutComponent
} from "./layout";
export default class TimelineHeaderPanelLayout extends HeaderPanel {
    get _propsInfo() {
        return {
            twoWay: [],
            allowNull: [],
            elements: [],
            templates: ["dateCellTemplate", "timeCellTemplate", "dateHeaderTemplate", "resourceCellTemplate"],
            props: ["dateHeaderData", "isRenderDateHeader", "dateCellTemplate", "timeCellTemplate", "dateHeaderTemplate", "groups", "groupOrientation", "groupPanelData", "groupByDate", "height", "className", "resourceCellTemplate"]
        }
    }
    get _viewComponent() {
        return TimelineHeaderPanelLayoutComponent
    }
}
registerComponent("dxTimelineHeaderPanelLayout", TimelineHeaderPanelLayout);
